<template>
  <el-dialog
    :title="$t('CargoMsg.Cargo_BatchEnterModifyBusinessOrderNo')"
    :visible.sync="innerVisible"
    style="width: 600px;"
  >
    <el-form>
      <el-form-item :label="$t('CargoMsg.Cargo_BusinessDocNoP')">
        <el-input v-model="txtNo" style="width: 200px;" no="1" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_WriteOffStartingPeriodP')">
        <el-checkbox v-model="chkInit" no="2" />
      </el-form-item>
      <el-form-item>
        <el-button no="3" @click="saveClickHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button no="4" @click="closeHandler">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as accountingEntryApi from '@/api/financeManage/accountingEntry'

export default {
  name: 'InputAuxiliaryNumberDialog',
  props: {
    visible: { type: Boolean, required: true },
    entryList: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      txtNo: '',
      chkInit: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    saveClickHandler() {
      if (!this.entryList || this.entryList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VoucherEntryCanTBeEmpty'))
        return
      }
      let checkAccount = true
      let accountId = 0
      const uuids = []
      for (const item of this.entryList) {
        const uuid = item['UUID']
        if (accountId <= 0) {
          accountId = item['ACCOUNT_CLIENT']
        } else {
          if (item['ACCOUNT_CLIENT'] > 0 && accountId > 0 && accountId !== item['ACCOUNT_CLIENT']) {
            checkAccount = false
            break
          }
          accountId = item['ACCOUNT_CLIENT']
        }
        uuids.push(uuid)
      }
      if (!checkAccount) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyMustBeConsistent'))
        return
      }
      if (!this.txtNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ProjectNumberNotNull'))
        return
      }
      const params = {}
      params.uuids = uuids
      params.projectNumber = this.txtNo
      params.beginPaidOff = this.chkInit
      const loading = getLoading()
      accountingEntryApi.batchUpdateAuxiliaryNumbers(params).then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
        this.$emit('refresh')
        this.closeHandler()
      }).finally(() => loading.close())
      // AccountingEntry.batchUpdateAuxiliaryNumbers(uuids, txtNo.text, chkInit.selected, new mx.rpc.Responder(batchUpdateAuxiliaryNumbersHandler, faultHandler))
    },
    closeHandler() {
      this.txtNo = ''
      this.chkInit = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
